/** Country-specific integration adapters. Argentina is the first implementation. */

export type CountryRuntimeConfig = {
  countryCode: string;
  currency: string;
  locale: string;
  taxSystemCode: string;
};

export function resolveCountryRuntimeConfig(input: {
  countryCode?: string | null;
  countryProfile?: { default_currency?: string; default_locale?: string; tax_system_code?: string } | null;
}): CountryRuntimeConfig {
  const countryCode = input.countryCode ?? 'AR';
  const profile = input.countryProfile;
  return {
    countryCode,
    currency: profile?.default_currency ?? 'ARS',
    locale: profile?.default_locale ?? 'es-AR',
    taxSystemCode: profile?.tax_system_code ?? 'ar_afip',
  };
}

export function formatMoneyForCountry(amount: number, config?: CountryRuntimeConfig): string {
  const runtime = config ?? resolveCountryRuntimeConfig({});
  return new Intl.NumberFormat(runtime.locale, {
    style: 'currency',
    currency: runtime.currency,
    maximumFractionDigits: 2,
  }).format(amount);
}
